export default "__VITE_ASSET__qqxqoEry__"